import React, { useEffect } from 'react';
import styles from './fdkt_wendril_instrutor78_.module.scss';
import { FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import FDKT from './src/fdkt.png';

const Fdkt_wendril_instrutor78_: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.fdkt_wendril_instrutor78_}>
            <div className={styles.header}>
                <Link to="/wendril_instrutor78_" className={styles.backButton}>
                    <FaArrowLeft />
                </Link>
                <h2>FIT DANCE KIDS E TEEN</h2>
            </div>

            <div className={styles.content}>
                <p>
                    As aulas de <strong>Fit Dance Kids e Teen</strong> são desenvolvidas especialmente para crianças e adolescentes de <strong>4 a 13 anos</strong>, unindo diversão, movimento e muita energia!
                </p>
                <p>
                    Com coreografias alegres, ritmos contagiantes e linguagem acessível, as aulas ajudam no desenvolvimento físico, coordenação motora, autoestima e sociabilidade das crianças.
                </p>
                <p>
                    Ministradas por <strong>Wendril, instrutor certificado</strong>, cada aula é pensada com carinho para garantir que os pequenos se expressem com liberdade e segurança.
                </p>
                <div className={styles.imageContainer}>
                    <img src={FDKT} alt="" />
                </div>
                <a
                    href="https://wa.me/5517988120941?text=Olá, gostaria de mais informações..."
                    target="_blank" className={styles.btnContato}>
                    Clique para mais informações
                </a>
            </div>
        </div>
    );
};

export default Fdkt_wendril_instrutor78_;
